import { render, staticRenderFns } from "./ChooseReceivingOrder.vue?vue&type=template&id=f1a0b694&scoped=true&"
import script from "./ChooseReceivingOrder.vue?vue&type=script&lang=js&"
export * from "./ChooseReceivingOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChooseReceivingOrder.vue?vue&type=style&index=0&id=f1a0b694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a0b694",
  null
  
)

export default component.exports